import React, { useState, useRef, useEffect, useContext } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { getDueDayRuleText, getGridLocalization, getPostponedDueDateText, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, showMessage } from "../../common/Helpers";
import { handlerFilter, removeGridLocalStorageFilters, useFilterActionComponentData } from "../../common/Helpers/JqxGridFilter";
import { useGetContractByElementId } from "../../hooks/services/sKPI/useOfBoard";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { useGetObligationAchieveById, useGetObligationAchieves, useGetObligationElementList } from "../../hooks/services/sCO/useOfObligacion";
import moment from "moment";
import { ActionButton, DatePicker, DefaultButton, DialogType, Icon, DialogFooter, PrimaryButton, Dialog, SpinnerSize, IconButton } from "@fluentui/react";
import SidePanelAchieveValidateNotification from "../sNotificationTasks/SidePanels/AchieveValidate/SidePanelAchieveValidateNotification";
import { activateOgligation, deactivateOgligation, getObligationAchieveElement, getObligationElement, setNexDueDateOgligation } from "../../services/sCO/obligationElement.service";
import { __MessageTypes, enum__AppElementType, enum__NOTIFICATION_CUMPLIMIENTO_ID, enum__NOTIFICATION_VALIDACION_ID } from "../../common/Dictionaries";
import DOMPurify from 'dompurify';
import { __GetClientRoleCode, CalendarCustomInput } from "../../common/CommonFuctions";
import { __onGoToElementObligationAchives } from "../../common/SystemRedirections";
import { useBoolean } from '@fluentui/react-hooks';
import Loading from "../../components/Templates/Site/Loading";
import MessageBox from "../../components/Common/Message/MessageBox";
import './style.css';
import MainAppContext from "../../MainAppContext";
import { useGetUserPropsKpi } from "../../hooks/services/sPrivilege/useOfPrivilege";
import { useSelector } from "react-redux";


export default function ElementObligations(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const { token: currentAuth } = useSelector((state) => state.auth);
    
    const queryStringElementId = !isNullUndefinedOrEmpty(props.match.params.elementId) ? props.match.params.elementId : null;
    const queryStringObligationIdSelectedId = !isNullUndefinedOrEmpty(props.match.params.obligationIdSelected) ? props.match.params.obligationIdSelected : null;

    const gridRef = useRef();

    const [isPanelAchieveValidateOpen, setIsPanelAchieveValidateOpen] = useState(false);
    const [isDialogNexDueDateOpen, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [nexDueDateActionActivateobligation, setNexDueDateActionActivateobligation] = useState(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [notificationId, setNotificationId] = useState(null);
    const [notificationTaskSelected, setNotificationTaskSelected] = useState(null);
    const [forceGetNotification, setForceGetNotification] = useState(false);

    const [userProps, setUserProps] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(12, null, queryStringElementId, currentAuth.token.userName, userProps, setUserProps)

    

    const [objObligation, setObjObligation] = useState(null);
    const [obligationList, setObligationList] = useState(null);
    useGetObligationElementList(queryStringElementId, obligationList, setObligationList, setObjObligation, queryStringObligationIdSelectedId);

    const [objContract, setObjContract] = useState(null);
    useGetContractByElementId(queryStringElementId, objContract, setObjContract);

    const [listObligationAchieves, setListObligationAchieves] = useState(null);
    useGetObligationAchieves(queryStringElementId, !isNullUndefined(objObligation) ? objObligation.id : null, listObligationAchieves, setListObligationAchieves);

    useFilterActionComponentData(gridRef, null, "ObligationAchieves");
    useGetObligationAchieveById(notificationId, setNotificationTaskSelected, forceGetNotification, setForceGetNotification)

    useEffect(() => {
        if (listObligationAchieves === null) {
            removeGridLocalStorageFilters("ObligationAchieves");
        }

    }, [listObligationAchieves]);

    const onShowAchieveValidatePanel = (item) => {
        let notificacionId = null;

        if (item.estadoCumplimientoId !== enum__NOTIFICATION_CUMPLIMIENTO_ID.CUMPLIDA) {
            notificacionId = item.notificacion_cumplimiento_id
        }
        else {
            if (item.estadoValidacionId === enum__NOTIFICATION_VALIDACION_ID.PENDIENTE) {
                notificacionId = item.notificacion_validar_id
            }
            else if (item.estadoValidacionId === enum__NOTIFICATION_VALIDACION_ID.RECHAZADA || item.estadoValidacionId === enum__NOTIFICATION_VALIDACION_ID.NOREQUIERE) {
                notificacionId = item.notificacion_cumplimiento_id
            }
            else if (isNullUndefinedOrEmptyOrZero(item.estadoValidacionId)) {
                notificacionId = item.notificacion_cumplimiento_id
            }
            else {
                notificacionId = item.notificacion_validar_id
            }
        }
        
        if (notificacionId !== null) {
            setNotificationTaskSelected(null);
            setNotificationId(notificacionId);
            setForceGetNotification(true);

            setIsPanelAchieveValidateOpen(true);
        }
    };

    const actionCellsRenderer = (itemId) => {
        const item = listObligationAchieves.l_cumplimientos.find(x => x.id === itemId);

        if (!item) {
            return <></>;
        }

        const isViewIcon = item.sujetaAValidacion === true
            ? item.estadoCumplimientoId === enum__NOTIFICATION_CUMPLIMIENTO_ID.CUMPLIDA &&
              item.estadoValidacionId !== enum__NOTIFICATION_VALIDACION_ID.PENDIENTE
            : item.estadoCumplimientoId === enum__NOTIFICATION_CUMPLIMIENTO_ID.CUMPLIDA;

        return <IconButton iconProps={{ iconName: isViewIcon ? "View" : "EntitlementRedemption" }} onClick={() => onShowAchieveValidatePanel(item)} />;
    };

    const getColumns = () => {
        const basicColumns = [
            { index: 1,    text: t('data-lang-lbl-duedate'),         dataField: 'fechaVencimiento',               uploadMasive: false, exportable: true,  width: '210px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-duedate-1')}<br />${t('data-lang-lbl-duedate-2')}</span></div>`; },
                // Si «Vencimiento se posterga» la corre al lunes: «sáb 28-Feb-26, vence lun 02-Mar-26».
                cellsrenderer: (row, column, value, defaulthtml, columnproperties, rowdata) => {
                    const text = getPostponedDueDateText(value, rowdata?.fechaVencimientoEfectiva, t) ?? (!isNullUndefinedOrEmpty(value) ? moment(value).format('DD-MMM-YY') : t('no-data'));
                    return `<div class="h-100 w-100" style="margin-left: 8px; padding-top: 9px">${text}</div>`;
                }
            },
            { index: 2,    text: t('data-lang-lbl-achievement'),     dataField: 'nombreEstadoCumplimiento',       uploadMasive: false, exportable: true,  width: '110px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-achievestatus-1')}<br />${t('data-lang-lbl-achievestatus-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    const color = listObligationAchieves.l_cumplimientos[row].estadoCumplimientoColor;
                    return `<div class="h-100 w-100" style="padding-left: 8px; padding-top: 9px; color:${color}; margin-left: 0px">${`<div class="col col-auto my-auto"><b>${value}</b></div>`}</div>`;
                }
            },
            { index: 3,    text: t('data-lang-lbl-achievedate'),     dataField: 'fechaCumplimiento',              uploadMasive: false, exportable: true,  width: '120px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-achievedate-1')}<br />${t('data-lang-lbl-achievedate-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) ? moment(value).format('DD-MMM-YY') : t('no-data')}</div>`;
                }
            },
            { index: 4,    text: t('data-lang-lbl-daysaheadbehind'), dataField: 'diasAtrasoAdelanto',             uploadMasive: false, exportable: true,  width: '130px',editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-daysaheadbehind-1')}<br />${t('data-lang-lbl-daysaheadbehind-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => { return `<div style="margin-left: 8px; margin-top: 9px">${(!isNullUndefinedOrEmpty(value) ? (value >= 0 ? `+${value}` : `-${value}`) : t('no-data'))}</div>`; }
            },
            { index: 5,    text: t('data-lang-lbl-userachieve'),     dataField: 'fullUsuarioDeclaraCumplimiento', uploadMasive: false, exportable: true,  width: '160px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-userachieve-1')}<br />${t('data-lang-lbl-userachieve-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefined(value) ? value : t('no-data')}</div>`;
                }
            },
            { index: 6,    text: t('data-lang-lbl-achievestatus'),   dataField: 'nombreEstadoValidacion',         uploadMasive: false, exportable: true,  width: '100px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-validationstatus-1')}<br />${t('data-lang-lbl-validationstatus-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefined(value) ? value : t('no-data')}</div>`;
                }
            },
            { index: 7,    text: t('data-lang-lbl-validationdate'),  dataField: 'fechaValidacion',                uploadMasive: false, exportable: true,  width: '110px',editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-validationdate-1')}<br />${t('data-lang-lbl-validationdate-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefinedOrEmpty(value) ? moment(value).format('DD-MMM-YY') : t('no-data')}</div>`;
                }
            },
            { index: 8,    text: t('data-lang-lbl-uservalidate'),    dataField: 'fullUsuarioDeclaraValidacion',   uploadMasive: false, exportable: true,  width: '130px', editable: false,
                renderer: function () { return `<div style="padding-top: 9px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-left: 4px; margin-right: 2px;"><span style="text-overflow: ellipsis; cursor: default;">${t('data-lang-lbl-uservalidate-1')}<br />${t('data-lang-lbl-uservalidate-2')}</span></div>`; },
                cellsrenderer: (row, column, value) => {
                    return `<div class="h-100 w-100" style="margin-left: 8px; padding-top: 9px">${!isNullUndefined(value) ? value : t('no-data')}</div>`;
                }
            },
            { index: 9,    text: t('data-lang-lbl-detail'),          dataField: 'id',                             uploadMasive: false, exportable: true,  width: '55px',
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(value), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(value), htmlElement); },
            },
        ]
            
        return basicColumns;
    };

    const getDataFields = () => {
        const basicDataFields = [
            { name: 'id',                             type: 'number' },
            { name: 'nombreEstadoCumplimiento',       type: 'string' },
            { name: 'nombreEstadoValidacion',         type: 'string' },
            { name: 'estadoCumplimientoId',           type: 'number' },
            { name: 'estadoValidacionId',             type: 'number' },
            { name: 'estadoCumplimientoColor',        type: 'string' },
            { name: 'fechaCumplimiento',              type: 'string' },
            { name: 'fechaValidacion',                type: 'string' },
            { name: 'fechaVencimiento',               type: 'string' },
            { name: 'fechaVencimientoEfectiva',       type: 'string' },
            { name: 'diasAtrasoAdelanto',             type: 'string' },
            { name: 'fullUsuarioDeclaraCumplimiento', type: 'string' },
            { name: 'fullUsuarioDeclaraValidacion',   type: 'string' },
            { name: 'notificacion_validar_id',        type: 'number' },
            { name: 'notificacion_cumplimiento_id',   type: 'number' },
        ]
    
        return basicDataFields
    };

    const onDeactivateClick = async () => {
        await deactivateOgligation(queryStringElementId, objObligation.id, objObligation.fechaProximoVencimiento).then(async (serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                setObjObligation(prevState => ({ ...prevState, activa: false }));
                setListObligationAchieves(null);
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))  
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };

    const onSelectNextDueDateClick = () => {
        setNexDueDateActionActivateobligation(true)
        showDialog()
    };
  
    const onSetNexDueDateClick = async () => {
        await setNexDueDateOgligation(queryStringElementId, objObligation.id, objObligation.fechaProximoVencimiento).then(async (serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                setNexDueDateActionActivateobligation(null);
                setObjObligation && setObjObligation(prevState => ({ ...prevState, fechaProximoVencimiento: objObligation.fechaProximoVencimiento }));
                setListObligationAchieves(null);
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                onCloseDialog();
            }
            else {
                setNexDueDateActionActivateobligation(null);
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }  
        }).catch(() => {
            setNexDueDateActionActivateobligation(null);
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onActivateClick = async () => {
        await activateOgligation(queryStringElementId, objObligation.id, objObligation.fechaProximoVencimiento).then(async (serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                setObjObligation && setObjObligation(prevState => ({ ...prevState, activa: true }));
                setListObligationAchieves(null);
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))  
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };
    
    const onSelectObligation = async (obligation) => {
        await getObligationElement(queryStringElementId, obligation.id).then((serviceResponse) => {
            if (serviceResponse.data.succeeded) {
                if (serviceResponse.data.succeeded) {
                    setObjObligation(serviceResponse.data.data);
                    setListObligationAchieves(null);

                    /*await getObligationAchieveElement(queryStringElementId, obligation.id).then(async (serviceListResponse) => {
                        if (serviceListResponse.data.succeeded) {
                            if (serviceListResponse.data.succeeded) {
                                setListObligationAchieves(serviceListResponse.data.data);
                            }
                            else {
                                setListObligationAchieves([])
                            }
                        }
                        else {
                            setListObligationAchieves([])
                        }  
                    }).catch(() => {
                        setListObligationAchieves([])
                    });*/
                }
                else {
                    setObjObligation({})
                }
            }
            else {
                setObjObligation({})
            }  
        }).catch(() => {
            setObjObligation({})
        });
    };

    const handleDateChange = (value) => {
        setObjObligation(prevState => ({
            ...prevState,
            fechaProximoVencimiento: value
        }));
    };

    const onCloseDialog = () => {
        hideDialog()
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        hideDialog();
    };

    const onForceGetAchieveList = () => {
        setListObligationAchieves(null)
    }

    const onFormatDate = (date) => {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    return (
        <div className="col-12 listWithActions h-100">
            {
                obligationList && objContract &&
                <div className="align-items-center h-100">
                    <Row className="px-2">
                        <Col xl={5}>
                            <Row className="">
                                <Col className="pb-2">
                                    <Card>
                                        <Card.Header className="card-header-compact">
                                            <Card.Title className="d-flex justify-content-between">
                                                <b>{t('data-lang-boxname-contractinformation')}</b>
                                            </Card.Title>
                                        </Card.Header>
                                        <Card.Body>
                                            {
                                                objContract &&
                                                <Row className="w-100">
                                                    <Col>
                                                        <Row><Col><b>{t('data-lang-lbl-contractcode-short')}</b></Col></Row>
                                                        <Row><Col>{objContract.contractCode}</Col></Row>
                                                    </Col>
                                                    <Col>
                                                        <Row><Col><b>{t('data-lang-lbl-areaname-short')}</b></Col></Row>
                                                        <Row><Col>{objContract.legalEntityBuyerName}</Col></Row>
                                                    </Col>
                                                    <Col>
                                                        <Row><Col><b>{t('data-lang-lbl-eecc')}</b></Col></Row>
                                                        <Row><Col>{objContract.legalEntitySupplierName}</Col></Row>
                                                    </Col>
                                                </Row>
                                            }
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={5} className="">
                                    <Card>
                                        <Card.Header className="card-header-compact">
                                            <Card.Title className="d-flex justify-content-between">
                                                <b>{t('data-lang-boxname-obligations')}</b>
                                            </Card.Title>
                                        </Card.Header>
                                        <Card.Body className="p-0 m-0" style={{ overflowY: "auto" }}>
                                            <div style={{height: '700px'}}>
                                                {
                                                    obligationList && obligationList.map(obligation =>(
                                                        <div
                                                            className="border cursor-pointer px-2"
                                                            onClick={() => onSelectObligation(obligation) }
                                                            style={{backgroundColor: !isNullUndefined(objObligation) ? (obligation.id === objObligation.id ? "#e4e4e4" : "unset") : 'unset'}}
                                                        >
                                                            <div><b>{obligation.nombre}</b></div>
                                                            <div style={{fontSize: "11px"}}>{obligation.nombreNemo}</div>
                                                            <div style={{fontSize: "11px"}}>{obligation.categoriaNombre}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col xl={7} className="">
                                    <Card>
                                        <Card.Header className="card-header-compact">
                                            <Card.Title className="d-flex justify-content-between">
                                                <b>{t('data-lang-boxname-obligation')}</b>
                                            </Card.Title>
                                        </Card.Header>
                                        <Card.Body>
                                            {
                                                objObligation &&
                                                <Row>
                                                    <Col>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-category')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.categoriaNombre) ? objObligation.categoriaNombre : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-sublegalentity')}</Col>
                                                            <Col className="border-bottom">
                                                                {
                                                                    (objObligation.subLegalEntities || []).length > 0
                                                                        ? objObligation.subLegalEntities.map(x => <span key={x.legalEntityId} className="badge bg-secondary me-1" title={x.legalEntityName}>{x.legalEntityCode}</span>)
                                                                        : t('no-data')
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-name')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.nombre) ? objObligation.nombre : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-description')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.descripcion) ? objObligation.descripcion : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-alertperioddais')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.periodoAlerta) ? objObligation.periodoAlerta : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-canachievebeforeduedate-long')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.cumplirAntesVencimiento) ? (objObligation.cumplirAntesVencimiento === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-postponeexpiration-long')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.postergarVencimiento) ? (objObligation.postergarVencimiento === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-finesnoncompliance-long')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.multaIncumplimiento) ? (objObligation.multaIncumplimiento === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-clausulamulta')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.clausulaMulta) ? objObligation.clausulaMulta : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-preventadnapproval')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.impedirAprobacionAdn) ? (objObligation.impedirAprobacionAdn === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-responsibleroleachieve-long')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.rolResponsableCumplimiento) ? __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, objObligation.rolResponsableCumplimiento) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-requiredattacheddocument-long')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.requiereDocumento) ? (objObligation.requiereDocumento === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-includeinedpchecklist')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.id) ? (objObligation.incluirEnChecklistEdp === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-obligationreqvalidation')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.sujetaAValidacion) ? (objObligation.sujetaAValidacion === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-responsiblerolevalidation-long')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.rolResponsableValidacion) ? __GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, objObligation.rolResponsableValidacion) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-periodic')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.periodica) ? (objObligation.periodica === true ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold border-bottom">{t('data-lang-lbl-periodicityonths')}</Col>
                                                            <Col className="border-bottom">{!isNullUndefined(objObligation.periodicidadMeses) ? objObligation.periodicidadMeses : t('no-data')}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="fw-bold">{t('data-lang-lbl-duedayrule')}</Col>
                                                            <Col>{getDueDayRuleText(objObligation, t)}</Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            }
                                            {
                                                !objObligation &&
                                                <div>{t('data-lang-msg-selectobligation')}</div>
                                            }
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                        <Col xl={7}>
                            <Card>
                                <Card.Header className="card-header-compact">
                                    <Card.Title className="justify-content-between">
                                        <b>{t('data-lang-boxname-achievements')}</b>: {!isNullUndefined(objObligation) ? objObligation.nombre : ''}
                                    </Card.Title>
                                </Card.Header>
                                <Card.Footer>
                                    <Row>
                                        <Col>
                                            <MessageBox
                                                inputParam_Message={ messageConfig.message }
                                                inputParam_Display={ messageConfig.showMessage }
                                                inputParam_MessageType={ messageConfig.messageType }
                                                inputParam_SetterMessage={ setMessageConfig }
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-auto ms-auto">
                                        {
                                            userProps && userProps.l_privilegeselement && (userProps.l_privilegeselement.flatMap(item => item.l_item_member).find(x => x.l_matrix.find(y => y.roleCode === 'AAD')) || (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin)) && 
                                            <>
                                                {
                                                    objObligation && objObligation.activa &&
                                                    <>
                                                        <ActionButton iconProps={{ iconName: 'ActivateOrders' }} disabled={true} allowDisabledFocus>{ t('data-lang-btn-activate') }</ActionButton>
                                                        <ActionButton iconProps={{ iconName: 'DeactivateOrders' }} allowDisabledFocus onClick={onDeactivateClick}>{ t('data-lang-btn-deactivated') }</ActionButton>
                                                    </>
                                                }
                                                {
                                                    userProps && objObligation && !objObligation.activa &&
                                                    <>
                                                        <ActionButton iconProps={{ iconName: 'ActivateOrders' }} allowDisabledFocus onClick={onActivateClick}>{ t('data-lang-btn-activate') }</ActionButton>
                                                        <ActionButton iconProps={{ iconName: 'DeactivateOrders' }} disabled={true} allowDisabledFocus>{ t('data-lang-btn-deactivated') }</ActionButton>
                                                    </>
                                                }
                                                {
                                                    userProps && objObligation && objObligation.activa &&
                                                    (
                                                        (objObligation.sujetaAValidacion === false && objObligation.estadoCumplimientoId !== enum__NOTIFICATION_CUMPLIMIENTO_ID.CUMPLIDA) ||
                                                        (objObligation.sujetaAValidacion === true && objObligation.estadoValidacionId !== enum__NOTIFICATION_VALIDACION_ID.OK)
                                                    ) &&
                                                    <ActionButton iconProps={{ iconName: 'Calendar' }} allowDisabledFocus onClick={onSelectNextDueDateClick}>{ t('data-lang-btn-nextduedate') }</ActionButton>
                                                }
                                                {
                                                    userProps && objObligation && !objObligation.activa &&
                                                    <ActionButton iconProps={{ iconName: 'Calendar' }} disabled={true} allowDisabledFocus>{ t('data-lang-btn-nextduedate') }</ActionButton>
                                                }
                                            </>
                                        }
                                        </Col>
                                    </Row>
                                </Card.Footer>
                                <Card.Footer>
                                    <Row>
                                        <Col className="text-center fw-bold w-100 p-0">
                                            {
                                                !isNullUndefined(listObligationAchieves) &&
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(listObligationAchieves.obligacionEstadoColor, { USE_PROFILES: { html: true } }) }}></div>
                                            }
                                        </Col>
                                        <Col className="border-start border-end">
                                            <div className="fw-bold">{t('data-lang-lbl-nextexpirationdate')}</div>
                                            <div style={{textAlign: "left"}}>{!isNullUndefined(listObligationAchieves) && !isNullUndefined(listObligationAchieves.fechaProximoVencimiento) ? (getPostponedDueDateText(listObligationAchieves.fechaProximoVencimiento, listObligationAchieves.fechaProximoVencimientoEfectiva, t) ?? moment(listObligationAchieves.fechaProximoVencimiento).format('DD-MMM-YY')) : t('no-data')}</div>
                                        </Col>
                                        <Col className="border-end">
                                            <div className="fw-bold">{t('data-lang-lbl-complianceindex')}</div>
                                            <div style={{textAlign: "left"}}>{!isNullUndefined(listObligationAchieves) && !isNullUndefined(listObligationAchieves.indiceCumplimiento) ? `${listObligationAchieves.indiceCumplimiento}%` : t('no-data') }</div>
                                        </Col>
                                        <Col>
                                            <div className="fw-bold">{t('data-lang-lbl-complianceindex-final')}</div>
                                            <div style={{textAlign: "left"}}>{!isNullUndefined(listObligationAchieves) && !isNullUndefined(listObligationAchieves.indiceCumplimientoFinal) ? `${listObligationAchieves.indiceCumplimientoFinal}%` : t('no-data') }</div>
                                        </Col>
                                    </Row>
                                </Card.Footer>
                                <Card.Footer></Card.Footer>
                                <Card.Body className="p-0 m-0">
                                    <Row>
                                        <Col>
                                        {
                                            listObligationAchieves && listObligationAchieves.l_cumplimientos &&
                                            <JqxGrid
                                                ref={gridRef}
                                                altrows={true}
                                                enabletooltips={true}
                                                width={'100%'}
                                                theme={'light'} 
                                                height={'800px'}
                                                editable={true}
                                                sortable={true}
                                                filterable={true}
                                                showfilterrow={true} 
                                                localization={getGridLocalization(t)}
                                                source={ new jqx.dataAdapter({
                                                    localData: listObligationAchieves.l_cumplimientos,
                                                    dataType: 'array',
                                                    dataFields: getDataFields(),
                                                    id: 'id'
                                                })}
                                                columns={getColumns()}
                                                onFilter={(event) => handlerFilter(event, 'ObligationAchieves')}
                                            />
                                        }
                                        </Col>
                                    </Row>
                                </Card.Body>
                                {
                                    nexDueDateActionActivateobligation === true &&
                                    <Dialog
                                        hidden={!isDialogNexDueDateOpen}
                                        onDismiss={onHideDialog}
                                        minWidth={500}
                                        maxWidth={650}
                                        dialogContentProps={{
                                            type: DialogType.normal,
                                            styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                                            title: t('data-lang-boxname-selectnextduedate'),
                                        }}
                                        modalProps={{
                                            isBlocking: true,
                                        }}
                                    >
                                        {
                                            objObligation &&
                                            <div style={{width: "100%", height: "100px"}} className="access-per-month-form-body overflow-hidden">
                                                <div className="align-items-center h-100">
                                                    <Row className='pb-2 pt-4'>
                                                        <Col xl={7}>
                                                            {t('data-lang-lbl-selectnextduedate')}
                                                        </Col>
                                                        <Col xl={5}>
                                                            <DatePicker
                                                                value={!isNullUndefinedOrEmpty(objObligation.fechaProximoVencimiento) ? new Date(objObligation.fechaProximoVencimiento) : null }
                                                                onSelectDate={handleDateChange}
                                                                width={"100%"}
                                                                formatDate={onFormatDate}
                                                                styles={{ root: { width: '100%' } }}
                                                                customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' />} /> }
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        }
                                        <DialogFooter>
                                            <Row>
                                                <Col></Col>
                                                <Col className="col-auto ms-auto">
                                                    <PrimaryButton className="mx-1" onClick={onSetNexDueDateClick} text={t('data-lang-btn-save')} />
                                                    <DefaultButton className="mx-1" onClick={onCloseDialog} text={t('data-lang-btn-close')} />
                                                </Col>
                                            </Row>
                                        </DialogFooter>
                                    </Dialog> 
                                }
                                {
                                    isPanelAchieveValidateOpen === true && !isNullUndefined(notificationTaskSelected) &&
                                    <SidePanelAchieveValidateNotification
                                        key={notificationId}
                                        inputParam_NotificationTask={notificationTaskSelected.item_notificacion}
                                        inputParam_IsPanelOpen={isPanelAchieveValidateOpen}
                                        inputParam_SetterIsPanelOpen={setIsPanelAchieveValidateOpen}
                                        inputParam_NeedUpdateNotificationPageList={false}
                                        inputParam_SkipActionListUpdate={true}
                                        inputParam_ExternalEventAfterSave={onForceGetAchieveList}
                                    />
                                }
                            </Card>
                        </Col>
                    </Row>
                </div>
            }
            {
                (!obligationList || !objContract) &&
                <Loading inputParam_ShowLoading={true} />
            }
        </div>
    ); 
}